<div class="access-denied-container">    
    <h2>Acesso Negado</h2>
    <p>Você não tem permissão para acessar esta página.</p>
    <button type="button" (click)="goBack()">Voltar para a página anterior</button>
    <div class="boxLogo mt-8">
        <img src="assets/images/gov-sp.png" alt="Image" class="logo" />
    </div>
</div>